import { createContext } from 'react';

export const CadastreArrayContext = createContext();